import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetStagesetsUnarchived as GetStagesetsUnarchivedQuery,
    GetStagesetsUnarchived_stagesets as StagesetUnarchived,
} from 'nutshell-graphql-types';

import GET_STAGESETS_UNARCHIVED from '../queries/get-stagesets-unarchived.graphql';

export const useGetStagesetsUnarchived = (): {
    stagesetsUnarchived: StagesetUnarchived[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetStagesetsUnarchivedQuery, Record<any, any>>(
        GET_STAGESETS_UNARCHIVED,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    const stagesets = data ? data.stagesets : null;

    return {
        stagesetsUnarchived: stagesets || [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
